import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { store } from 'redux-rest-reducer';
import { connect } from 'react-redux';

import React, { PureComponent } from 'react';
import { Module } from '@cuemath/comps';

import { getAll as getChapters } from 'actions/chapters';
import Chapter from './view';

class ChapterContainer extends PureComponent {
  static propTypes = {
    match: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types,
    chapters: PropTypes.array.isRequired, // eslint-disable-line react/forbid-prop-types,
    programCode: PropTypes.string.isRequired,
    actions: PropTypes.func.isRequired,
  };

  componentDidMount() {
    this.refreshData();
  }

  refreshData = () => {
    const { actions, programCode } = this.props;

    actions.getChapters({ program_code: programCode });
  };

  render() {
    const { chapters, programCode, match } = this.props;

    return (
      <Module
        match={match}
        module={Chapter}
        programCode={programCode}
        resource={chapters || {}}
        chapters={chapters ? chapters.data : {}}
      />
    );
  }
}

export default connect(
  ({ chapters }, { programCode }) => ({
    chapters: store.getAll(chapters, { program_code: programCode }),
  }),
  dispatch => ({
    actions: bindActionCreators({ getChapters }, dispatch),
  }),
)(ChapterContainer);
